import {
  FETCH_TIME_ENTRIES, FETCH_TIME_ENTRIES_SUCCESS, FETCH_TIME_ENTRIES_FAIL,
  START_TIME_ENTRY, START_TIME_ENTRY_SUCCESS, START_TIME_ENTRY_FAIL,
  STOP_TIME_ENTRY, STOP_TIME_ENTRY_SUCCESS, STOP_TIME_ENTRY_FAIL,
  ADD_MANUAL_TIME_ENTRY, ADD_MANUAL_TIME_ENTRY_SUCCESS, ADD_MANUAL_TIME_ENTRY_FAIL,
  UPDATE_TIME_ENTRY, UPDATE_TIME_ENTRY_SUCCESS, UPDATE_TIME_ENTRY_FAIL,
  DELETE_TIME_ENTRY, DELETE_TIME_ENTRY_SUCCESS, DELETE_TIME_ENTRY_FAIL,
  CLEAR_TIME_ENTRY_MESSAGES,
  SET_USER_HOURLY_RATE, SET_USER_HOURLY_RATE_SUCCESS, SET_USER_HOURLY_RATE_FAIL,
} from './actionTypes';

// List
export const fetchTimeEntries = (workOrderId) => ({ type: FETCH_TIME_ENTRIES, payload: workOrderId });
export const fetchTimeEntriesSuccess = (entries) => ({ type: FETCH_TIME_ENTRIES_SUCCESS, payload: entries });
export const fetchTimeEntriesFail = (error) => ({ type: FETCH_TIME_ENTRIES_FAIL, payload: error });

// Start timer
export const startTimeEntry = (workOrderId, notes, callback) => ({
  type: START_TIME_ENTRY,
  payload: { workOrderId, notes, callback },
});
export const startTimeEntrySuccess = (entry) => ({ type: START_TIME_ENTRY_SUCCESS, payload: entry });
export const startTimeEntryFail = (error) => ({ type: START_TIME_ENTRY_FAIL, payload: error });

// Stop timer
export const stopTimeEntry = (workOrderId, callback) => ({
  type: STOP_TIME_ENTRY,
  payload: { workOrderId, callback },
});
export const stopTimeEntrySuccess = (entry) => ({ type: STOP_TIME_ENTRY_SUCCESS, payload: entry });
export const stopTimeEntryFail = (error) => ({ type: STOP_TIME_ENTRY_FAIL, payload: error });

// Manual entry
export const addManualTimeEntry = (data, callback) => ({
  type: ADD_MANUAL_TIME_ENTRY,
  payload: { data, callback },
});
export const addManualTimeEntrySuccess = (entry) => ({ type: ADD_MANUAL_TIME_ENTRY_SUCCESS, payload: entry });
export const addManualTimeEntryFail = (error) => ({ type: ADD_MANUAL_TIME_ENTRY_FAIL, payload: error });

// Update
export const updateTimeEntry = (id, data, callback) => ({
  type: UPDATE_TIME_ENTRY,
  payload: { id, data, callback },
});
export const updateTimeEntrySuccess = (entry) => ({ type: UPDATE_TIME_ENTRY_SUCCESS, payload: entry });
export const updateTimeEntryFail = (error) => ({ type: UPDATE_TIME_ENTRY_FAIL, payload: error });

// Delete
export const deleteTimeEntry = (id, callback) => ({ type: DELETE_TIME_ENTRY, payload: { id, callback } });
export const deleteTimeEntrySuccess = (id) => ({ type: DELETE_TIME_ENTRY_SUCCESS, payload: id });
export const deleteTimeEntryFail = (error) => ({ type: DELETE_TIME_ENTRY_FAIL, payload: error });

export const clearTimeEntryMessages = () => ({ type: CLEAR_TIME_ENTRY_MESSAGES });

// Hourly rate setter (cost-config endpoint)
export const setUserHourlyRate = (userId, hourlyRate, callback) => ({
  type: SET_USER_HOURLY_RATE,
  payload: { userId, hourlyRate, callback },
});
export const setUserHourlyRateSuccess = () => ({ type: SET_USER_HOURLY_RATE_SUCCESS });
export const setUserHourlyRateFail = (error) => ({ type: SET_USER_HOURLY_RATE_FAIL, payload: error });
